<template>

  <div 
    ref     = "split_container"
    class   = "d-flex flex-row"
  >

    <!-- Left -->
    <div :style="leftStyle">
      <slot name="left"></slot>
    </div>

    <!-- Splitter -->
    <div 
      v-if    = "showSplitter"
      class   = "splitter"
    >
      <v-icon
        @mousedown    = "onPreviousXPositioned"
      >
        mdi-drag-vertical-variant
      </v-icon>
    </div>

    <!-- Right -->
    <div :style="rightStyle">
      <slot name="right"></slot>
    </div>

  </div>

</template>

<script>

export default {

  // #region Properties

  name:  'VerticalSplitPane',
  props: {
    split:     Number,
    hideLeft:  Boolean,
    hideRight: Boolean
  },
  data() {
    return {
      isResizing:        false,
      previousXPosition: 0
    };
  },
  computed: {
    leftStyle() {
      let width = this.split;

      if (this.hideLeft) {
        width = 0;
      } else if (this.hideRight) {
        width = 100;
      }

      return {
        'width': `${width}%`
      };
    },
    rightStyle() {
      let width = 100 - this.split;

      if (this.hideRight) {
        width = 0;
      } else if (this.hideLeft) {
        width = 100;
      }

      return {
        'width': `${width}%`
      };
    },
    showSplitter() {
      return !(this.hideLeft || this.hideRight);
    }
  },

  // #endregion Properties

  // #region Methods

  methods: {

    // #region Events

    onPreviousXPositioned(event) {
      this.isResizing = true;
      this.previousXPosition = event.clientX;

      document.body.style.cursor = 'ew-resize';
      window.addEventListener('mousemove', this.onResizing);
      window.addEventListener('mouseup', this.onResizeEnded);
    },

    onResizing(event) {
      if (!this.isResizing) {
        return;
      }

      const difference = event.clientX - this.previousXPosition;
      const width = this.$refs.split_container.offsetWidth;

      const percentDelta = (difference / width) * 100;
      const newSplit = Math.max(0, Math.min(100, this.split + percentDelta));
      this.$emit('resize', newSplit);
      
      this.previousXPosition = event.clientX;
    },

    onResizeEnded() {
      if (!this.isResizing) {
        return;
      }

      this.isResizing = false;

      document.body.style.cursor = 'default';
      window.removeEventListener('mousemove', this.onResizing);
      window.removeEventListener('mouseup', this.onResizeEnded);
    }

    // #endregion Events

  }

  // #endregion Methods

}

</script>

<style scoped lang="scss">

.splitter {
  display:        flex;
  justify-items:  center;

  .v-icon {
    cursor:   ew-resize;
  }
}

</style>